import React from 'react'
import { useSelector } from 'react-redux'

//redux
import { getUser } from 'app/store/profileSlice'
import { Outlet } from 'react-router-dom'

export default function EmployerProfileContainer() {
  const profile = useSelector(getUser)

  if (!profile) return null

  return (
    <div>
      <Outlet />
    </div>
  )
}
